import { mergeStyles } from '@cian/utils';
import * as React from 'react';

import { OfferMapInfrastructureCheckbox } from './checkbox';
import {
  cafesIcon,
  groceryStoresIcon,
  infrastructureIcon,
  kindergardenIcon,
  polyclinicsIcon,
  schoolIcon,
} from './icons';
import styles from './index.css';
import { InfrastructureType } from '../../../store/map';

import type { JSX } from 'react';

export interface IVillageInfrastructureProps {
  selected: InfrastructureType[];
  onSelect(type: InfrastructureType): void;
}

export interface IVillageInfrastructureState {
  isCollapsed: boolean;
}

export class VillageMapInfrastructure extends React.Component<
  IVillageInfrastructureProps,
  IVillageInfrastructureState
> {
  public state: IVillageInfrastructureState = {
    isCollapsed: false,
  };

  public render() {
    const { selected } = this.props;
    const { isCollapsed } = this.state;

    return (
      <div {...mergeStyles(styles['container'], isCollapsed && styles['container--collapsed'])}>
        <div className={styles['header']}>
          Инфраструктура
          <button className={styles['button-toggle']} onClick={() => this.setState({ isCollapsed: !isCollapsed })}>
            {infrastructureIcon}
          </button>
        </div>
        <ul className={styles['list']}>
          {this.createItem(
            InfrastructureType.Schools,
            schoolIcon,
            'Школы',
            selected.includes(InfrastructureType.Schools),
          )}
          {this.createItem(
            InfrastructureType.Kindergarden,
            kindergardenIcon,
            'Детские сады',
            selected.includes(InfrastructureType.Kindergarden),
          )}
          {this.createItem(
            InfrastructureType.Polyclinics,
            polyclinicsIcon,
            'Поликлиники',
            selected.includes(InfrastructureType.Polyclinics),
          )}
          {this.createItem(
            InfrastructureType.GroceryStores,
            groceryStoresIcon,
            'Продукт. магазины',
            selected.includes(InfrastructureType.GroceryStores),
          )}
          {this.createItem(InfrastructureType.Cafes, cafesIcon, 'Кафе', selected.includes(InfrastructureType.Cafes))}
        </ul>
      </div>
    );
  }

  private createItem(infrastructureType: number, icon: JSX.Element, title: string, isActive: boolean) {
    return (
      <li>
        <a
          {...mergeStyles(styles['item'], isActive && styles['item--active'])}
          onClick={() => this.props.onSelect(infrastructureType)}
        >
          <span>
            {icon}
            {title}
          </span>
          <OfferMapInfrastructureCheckbox active={isActive} />
        </a>
      </li>
    );
  }
}
